import React from "react";
import PropTypes from "prop-types";
import { ArrowBack } from "@material-ui/icons";
import { Typography, Grid } from "@material-ui/core";
import useStyles from "./viewHeaderStyles";
import translate from "../../../i18n/translate";
import SrButton from "../SrButton";

const ViewHeader = ({ title, description, onBackClick }) => {
  const classes = useStyles();

  return (
    <Grid>
      {onBackClick && (
        <SrButton
          className={classes.back}
          size="small"
          aria-label="delete"
          onClick={onBackClick}
          startIcon={<ArrowBack color="primary" />}
        >
          {translate("common.return")}
        </SrButton>
      )}
      <Typography className={`${classes.title}`}>{title}</Typography>
      {description && (
        <Typography className={classes.description}>{description}</Typography>
      )}
    </Grid>
  );
};

ViewHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onBackClick: PropTypes.func,
};

ViewHeader.defaultProps = {
  description: "",
  onBackClick: undefined,
};

export default ViewHeader;
